import {TweenMax, Quad, Bounce} from "gsap";
import ratingComponent from '../shared/rating.vue'
import reviewItem from './review-item.vue';

// intersectionObserver pollyfill
require('intersection-observer');

export default  {

  name: 'reviews-component',

  props: ['data'],

  components: {

    ratingComponent,
    reviewItem

  },

  data(){

    return{

      paging: 0

    }

  },

  computed:{

    reviews(){

      return this.$store.state.product.reviews

    }

  },

  methods: {

    onTouchEnd(e) {

      TweenMax.to( e.target, 0.6, {scale:1, opacity: 1, ease: Quad.easeOut });

      // tell the parent that close button wats clicked
      this.$parent.$emit('showReviews', false)

    },


    onTouchStart(e){

      TweenMax.to( e.target, 0.6, {scale:0.5, opacity: 1, ease: Quad.easeOut });

    },


    onIntersectionChange(changes) {

      /* Google for IntersectionObserver to know more */

      let vm = this;

      let product = this.$route.params.product;

      changes.forEach(function(change) {

        if(change.isIntersecting){

          vm.paging = vm.paging + 1;

          // Dispatch event to get product reviews by url parameter and save it on the store
          vm.$store.dispatch('get_product_reviews', { product: product, page: vm.paging });

        }else{


        }

      });

    },

    loadMore(){

      let loader = document.getElementById("loader");

      let scrollRoot = document.getElementById("scroll-root");

      // Intersection observer is supported
      if ('IntersectionObserver' in window) {

        // The observer
        var scrollObserver = new IntersectionObserver(this.onIntersectionChange, {

          root: scrollRoot, // root will be the parent container

          rootMargin: '250px', // fire it when loading element is at 250px from the bottom of the root

          threshold: 0.01

        });

        scrollObserver.observe(loader);


      }


    }

  },

  mounted(){

    // Init lazy load
    this.loadMore();
  }

}




// WEBPACK FOOTER //
// ./src/components/reviews/reviews.component.js